import { useEffect, useState } from 'react';
import { OverviewTestDataProps } from '../../dashboard/overview-models/overview.Interface';
import { useLocation, useNavigate } from 'react-router';
import { useQuery } from 'react-query';
import reportApi from '../../../api/report';

export default function useViewReport() {
  const [institutionId] = useState(localStorage.getItem('c-iid') || '');
  const [paramsData, setParamsData] = useState<OverviewTestDataProps>();
  const [xport, setXport] = useState<boolean>(false);
  const location = useLocation();
  const navigate = useNavigate();
  const { data, isLoading } = useQuery(
    [
      'getTestDetails',
      institutionId,
      paramsData?.testId,
      paramsData?.subjectId,
      paramsData?.periodId,
      paramsData?.categoryId,
      xport,
    ],
    () =>
      reportApi.getTestDetail(
        +institutionId,
        paramsData?.testId,
        paramsData?.subjectId,
        paramsData?.periodId,
        paramsData?.categoryId,
        xport
      )
  );

  useEffect(() => {
    if (location.state.test) {
      const paramData = location?.state?.test;
      setParamsData(paramData);
    } else {
      navigate('/dashboard');
    }
  }, [location]);

  return {
    data,
    paramsData,
    isLoading,
    setXport,
  };
}
